export const topics = [
  {
    name: 'Selección Argentina',
    slug: 'seleccion-argentina',
  },
  {
    name: 'Último momento',
    slug: 'ultimo-momento',
  },
  {
    name: 'Política',
    slug: 'politica',
  },
  {
    name: 'Economía',
    slug: 'ecnonomia',
  },
  {
    name: 'Deportes',
    slug: 'deportes',
  },
  {
    name: 'Coberturas en Vivo',
    slug: 'coberturas-en-vivo',
  },
  {
    name: 'Especiales Clarín',
    slug: 'especiales-clarin',
  },
  {
    name: 'Messi',
    slug: 'messi',
  },
  {
    name: 'Alejandro Borensztein',
    slug: 'alejandro-borensztein',
  },
  {
    name: 'Jorge Lanata',
    slug: 'jorge-lanata',
  },
  {
    name: 'Ricardo Kirschbaum',
    slug: 'ricardo-kirschbaum',
  },
  {
    name: 'Ricardo Roa',
    slug: 'ricardo-roa',
  },
  {
    name: 'Santiago Fioriti',
    slug: 'santiago-fioriti',
  },
];
